/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { retrieveDownloadsEndPoint, getDownloadsDetailEndPoint } from '../common/constants';
import { sendRequestAndReceiveResponse, filterNames, filterModels } from '../common/common';

const LOADING_DOWNLOAD_DETAIL = 'LOADING_DOWNLOAD_DETAIL';
const LOAD_DOWNLOAD = 'LOAD_DOWNLOAD';
const DOWNLOAD_DETAIL = 'DOWNLOAD_DETAIL';
const CLEAR_VIEW_DOWNLOAD_STORE = 'CLEAR_VIEW_DOWNLOAD_STORE';
const UPDATE_SERIAL_NUMBER = 'UPDATE_SERIAL_NUMBER';
const STOP_LOADING = 'STOP_LOADING';
const CLEAR_DOWNLOADS_LIST = 'CLEAR_DOWNLOADS_LIST';
const UPDATE_FAMILIES = 'UPDATE_FAMILIES';
const UPDATE_SELECTED_FAMILY = 'UPDATE_SELECTED_FAMILY';
const UPDATE_SELECTED_PRODUCTNAME = 'UPDATE_SELECTED_PRODUCTNAME';
const UPDATE_SELECTED_PRODUCTMODEL = 'UPDATE_SELECTED_PRODUCTMODEL';
const UPDATE_PRODUCTNAMES = 'UPDATE_PRODUCTNAMES';
const UPDATE_PRODUCTMODELS = 'UPDATE_PRODUCTMODELS';
const UPDATE_ALL_CLASSIFICATION = 'UPDATE_ALL_CLASSIFICATION';
const SERVICE_DOWNLOAD_DATA = 'SERVICE_DOWNLOAD_DATA';
const UN_SELECT_DOWNLOAD = 'UN_SELECT_DOWNLOAD';
const UPDATE_SELECTED_DOWNLOAD_IDS = 'UPDATE_SELECTED_DOWNLOAD_IDS';

const initialState = {
    data: {},
    families: [],
    productNames: [],
    productModels: [],
    serialNumber: ''
}

export const actionCreators = {
    UpdateSelectedFamily: (selectedFamilies: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_FAMILY, selectedFamilies });
        dispatch({ type: SERVICE_DOWNLOAD_DATA });
    },
    UpdateSelectedProductName: (SelectedProductNames: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_PRODUCTNAME, SelectedProductNames });
        dispatch({ type: SERVICE_DOWNLOAD_DATA });
    },
    UpdateSelectedProductModel: (SelectedProductModels: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_PRODUCTMODEL, SelectedProductModels });
        const downloadsData = await sendRequestAndReceiveResponse(
            JSON.stringify({
                'ClassificationId': SelectedProductModels[0],
                'ClassificationType': 'productmodel'
            }), retrieveDownloadsEndPoint);
        dispatch({ type: SERVICE_DOWNLOAD_DATA, downloadsData });
    },
    selectDownload: (data: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: LOADING_DOWNLOAD_DETAIL });
        const selectedDownload = await sendRequestAndReceiveResponse(
            JSON.stringify({
                'DownloadsId': data.downloadsId
            }), getDownloadsDetailEndPoint);
        dispatch({ type: DOWNLOAD_DETAIL, selectedDownload });
    },
    unselectDownload: () => async (dispatch: any, getState: any) => {
        dispatch({ type: UN_SELECT_DOWNLOAD });
    },
    updatedSelectedId: (selectedIds: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_DOWNLOAD_IDS, selectedIds });
    },

    UpdateProductClassificationonSerialNumber: (selectedFamily: any, selectedProductName: any, selectedProductModel: any, downloadsData: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_ALL_CLASSIFICATION, selectedFamily, selectedProductName, selectedProductModel, downloadsData });
    },
    FilterNames: (Productfamilies: any, selectedProductFamily: any,) => async (dispatch: any, getState: any) => {
        let productNames: any = [];
        productNames = filterNames(Productfamilies, selectedProductFamily);
        dispatch({ type: UPDATE_PRODUCTNAMES, productNames });
    },
    FilterModels: (ProductNames: any, selectedProductName: any,) => async (dispatch: any, getState: any) => {
        let productModels: any = [];
        productModels = filterModels(ProductNames, selectedProductName);
        dispatch({ type: UPDATE_PRODUCTMODELS, productModels });
    },
    UpdateProductFamilies: (families: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_FAMILIES, families });
    },
    LoadDownload: (serialNumber: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: LOAD_DOWNLOAD, serialNumber });
    },
    UpdateSerialNumber: (serialNumber: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SERIAL_NUMBER, serialNumber });
    },
    StopLoading: () => async (dispatch: any, getState: any) => {
        dispatch({ type: STOP_LOADING });
    },
    ClearViewDownloadsData: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_VIEW_DOWNLOAD_STORE });
    },
    ClearDownloadsList: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_DOWNLOADS_LIST });
    },
}

export const reducer = (state: any, action: any) => {
    state = state || initialState;

    switch (action.type) {
        case UPDATE_SELECTED_FAMILY:
            return {
                ...state,
                selectedFamily: action.selectedFamilies,
                selectedProductName: undefined,
                selectedProductModel: undefined,
                isDownloadsLoading: true,
                selectedDownload: undefined,
                selectedDownloadIds: undefined,
                serialNumber: ''
            };
        case UPDATE_SELECTED_PRODUCTNAME:
            return {
                ...state,
                selectedProductName: action.SelectedProductNames,
                selectedProductModel: undefined,
                isDownloadsLoading: true,
                selectedDownload: undefined,
                selectedDownloadIds: undefined,
                serialNumber: ''
            };
        case UPDATE_SELECTED_PRODUCTMODEL:
            return {
                ...state,
                selectedProductModel: action.SelectedProductModels,
                isDownloadsLoading: true,
                selectedDownload: undefined,
                selectedDownloadIds: undefined,
                serialNumber: ''
            };
        case SERVICE_DOWNLOAD_DATA:
            return {
                ...state,
                isDownloadsLoading: false,
                downloadsData: action.downloadsData
            };
        case LOADING_DOWNLOAD_DETAIL:
            return {
                ...state,
                loadingDownloadDetail: true
            };
        case DOWNLOAD_DETAIL:
            return {
                ...state,
                loadingDownloadDetail: false,
                selectedDownload: action.selectedDownload
            };
        case UN_SELECT_DOWNLOAD:
            return {
                ...state,
                selectedDownload: undefined
            };
        case UPDATE_SELECTED_DOWNLOAD_IDS:
            return {
                ...state,
                selectedDownloadIds: action.selectedIds
            };

        case UPDATE_ALL_CLASSIFICATION:
            return {
                ...state,
                selectedFamily: action.selectedFamily,
                selectedProductName: action.selectedProductName,
                selectedProductModel: action.selectedProductModel,
                downloadsData: action.downloadsData,
                isDownloadsLoading: false,
            };
        case UPDATE_FAMILIES:
            return {
                ...state,
                families: action.families
            };
        case UPDATE_PRODUCTNAMES:
            return {
                ...state,
                productNames: action.productNames
            };
        case UPDATE_PRODUCTMODELS:
            return {
                ...state,
                productModels: action.productModels
            };
        case LOAD_DOWNLOAD:
            return {
                ...state,
                isDownloadsLoading: true,
                serialNumber: action.serialNumber,
                selectedFamily: undefined,
                selectedProductName: undefined,
                selectedProductModel: undefined,
                selectedDownload: undefined
            };
        case UPDATE_SERIAL_NUMBER:
            return {
                ...state,
                serialNumber: action.serialNumber
            };
        case STOP_LOADING:
            return {
                ...state,
                isDownloadsLoading: false
            };
        case CLEAR_VIEW_DOWNLOAD_STORE: {
            return initialState;
        }
        case CLEAR_DOWNLOADS_LIST:
            return {
                ...state,
                downloadsData: undefined,
            };
    }

    return state;
};
